module.exports = __webpack_public_path__ + "img/logo-selina.6ff06dd5.png";